import {Vue} from "ui.vue";

import Mask from './plugins/v-mask/dist/v-mask.js';
import VeeValidate from './plugins/vue-validate/vue-validate.js';
import ru from './plugins/vue-validate/locale/ru';
import VueRecaptcha from './plugins/vue-recaptcha-master/vue-recaptcha.js';

import FormFieldWrap from './components/FormFieldWrap.vue';
import FormFieldText from './components/FormFieldText.vue';
import FormFieldPassword from './components/FormFieldPassword.vue';
import FormFieldPasswordConfirm from './components/FormFieldPasswordConfirm.vue';
import FormFieldEmail from './components/FormFieldEmail.vue';
import FormFieldFile from './components/FormFieldFile.vue';
import FormFieldCaptcha from './components/FormFieldCaptcha.vue';
import FormFieldPhone from './components/FormFieldPhone.vue';
import FormFieldTextarea from './components/FormFieldTextarea.vue';
import FormFieldHtml from './components/FormFieldHtml.vue';
import FormFieldRating from './components/FormFieldRating.vue';
import FormFieldMultiple from './components/FormFieldMultiple.vue';
import FormFieldCheckbox from './components/FormFieldCheckbox.vue';
import FormGroups from './components/FormGroups.vue';

import FormFieldSelect from './components/FormFieldSelect.vue';

import VueSelect from 'citrus.vue.vue-select';
Vue.use(VueSelect);

import PhoneMaskPlugin from 'citrus.vue.directive.v-phone-mask';
Vue.use(PhoneMaskPlugin);

Vue.use(VeeValidate);
VeeValidate.Validator.localize('ru', ru);

Vue.component('VueRecaptcha', VueRecaptcha);
Vue.component('FormFieldWrap', FormFieldWrap);
Vue.component('FormFieldText', FormFieldText);
Vue.component('FormFieldMultiple', FormFieldMultiple);
Vue.component("FormFieldPasswordConfirm", FormFieldPasswordConfirm);
Vue.component('FormGroups', FormGroups);
Vue.cloneComponent("FormFieldPassword", "FormFieldText", FormFieldPassword);
Vue.cloneComponent("FormFieldEmail", "FormFieldText", FormFieldEmail);
Vue.cloneComponent("FormFieldFile", "FormFieldText", FormFieldFile);
Vue.cloneComponent("FormFieldCaptcha", "FormFieldText", FormFieldCaptcha);
Vue.cloneComponent("FormFieldPhone", "FormFieldText", FormFieldPhone);
Vue.cloneComponent("FormFieldTextarea", "FormFieldText", FormFieldTextarea);
Vue.cloneComponent("FormFieldHtml", "FormFieldTextarea", FormFieldHtml);
Vue.cloneComponent("FormFieldRating", "FormFieldText", FormFieldRating);
Vue.cloneComponent("FormFieldCheckbox", "FormFieldText", FormFieldCheckbox);

Vue.cloneComponent("FormFieldSelect", "FormFieldText", FormFieldSelect);
